import { connect } from "react-redux";

import {
  toggleDeleteModal,
  toggleDeliveryModal,
  toggleEditModal,
} from "../../redux/modals";
import {
  fetchCalendar,
  openEvent,
  openApptEvent,
  rescheduleEventExplicit,
  scheduleAppointmentExplicit,
  scheduleBid,
  scheduleJobExplicit,
  schedulePurchaseOrderExplicit,
  setActiveCrew,
  setActiveEquipment,
  showApptContextMenuItem,
  hideMenuItem,
} from "../../redux/calendar";
import makeEventsByCrew from "../../selectors/eventsByCrew";
import makeEventsByEquipment from "../../selectors/eventsByEquipment";
import { open as togglePrintWorkOrderModal } from "../../redux/modals/printWorkOrderModal";
import EquipmentWeekView from "./EquipmentWeekView";
import {
  updateSettings,
  togglePinTotalsRow as togglePinTotalsRow,
  showEstimatedQuantitiesSelector,
} from "../../redux/settings";

import {
  toggleAppointmentModal as onOpenAppointmentCalendarModal,
  toggleApptEditModal as onOpenEditEventModel,
} from "../../redux/modals/appintmentCalendarModal";

const eventsByCrew = makeEventsByCrew(true);
const eventsByEquipment = makeEventsByEquipment(true);

const mapStateToProps = (state) => ({
  date: state.calendar.date,
  equipments: state.equipments,
  events: state.events,
  offices: state.settings.offices,
  eventsByCrew: eventsByCrew(state),
  eventsByEquipment: eventsByEquipment(state),
  hasCalendarEventCreate:
    state.tokenInfo.scope.indexOf("calendarEvents:create") > -1,
  hasCalendarEventDelete:
    state.tokenInfo.scope.indexOf("calendarEvents:delete") > -1,
  hasCalendarEventUpdate:
    state.tokenInfo.scope.indexOf("calendarEvents:update") > -1,
  showApptMenuItem: state.calendar.showApptMenuItem,
  showMenuItem: state.calendar.showMenuItem,
  settings: state.settings,
  mode: state.calendar.mode,
  showTotalsRow: state.settings.totalsRowFields.fields.showTotalsRow.visible,
  showUOMTotals:
    state.settings.totalsRowFields.fields.statistics.uomTotals.visible,
  showJobCounts:
    state.settings.totalsRowFields.fields.statistics.jobCounts.visible,
  includedItemTypes: state.settings.totalsRowFields.fields.includedItemTypes,
  showEstimatedQuantities: showEstimatedQuantitiesSelector(state),
  pinTotalsRow: state.settings.pinTotalsRow,
});

const mapDispatchToProps = {
  onCrewSelect: setActiveCrew,
  onNavigate: fetchCalendar,
  onDeleteEventClick: toggleDeleteModal,
  onEditDeliveryClick: toggleDeliveryModal,
  onEditEventClick: toggleEditModal,
  onOpenClick: openEvent,
  onOpenApptEventClick: openApptEvent,
  onReschedule: rescheduleEventExplicit,
  onScheduleBid: scheduleBid,
  onScheduleDelivery: schedulePurchaseOrderExplicit,
  onScheduleJob: scheduleJobExplicit,
  onPrintWorkOrder: togglePrintWorkOrderModal,
  onEquipmentSelect: setActiveEquipment,
  onSheeduleAppointment: scheduleAppointmentExplicit,
  updateSettings: updateSettings,
  onContextMenuClick: showApptContextMenuItem,
  onApptEditEventClick: (eventid, show) =>
    onOpenEditEventModel({ eventid, show: show }),
  onJobContextMenuClick: hideMenuItem,
  onTogglePinTotalsRow: togglePinTotalsRow,
};

const mergeProps = (
  {
    hasCalendarEventCreate,
    hasCalendarEventDelete,
    hasCalendarEventUpdate,
    ...stateProps
  },
  {
    onDeleteEventClick,
    onEditDeliveryClick,
    onEditEventClick,
    onReschedule,
    onScheduleBid,
    onScheduleDelivery,
    onScheduleJob,
    onSheeduleAppointment,
    updateSettings,
    onPrintWorkOrder,
    onContextMenuClick,
    onApptEditEventClick,
    ...dispatchProps
  },
  ownProps
) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onDeleteEventClick: hasCalendarEventDelete ? onDeleteEventClick : null,
  onEditDeliveryClick: hasCalendarEventUpdate ? onEditDeliveryClick : null,
  onEditEventClick: hasCalendarEventUpdate ? onEditEventClick : null,
  onScheduleBid: hasCalendarEventCreate ? onScheduleBid : null,
  onReschedule: hasCalendarEventUpdate ? onReschedule : null,
  onScheduleDelivery: hasCalendarEventCreate ? onScheduleDelivery : null,
  onScheduleJob: hasCalendarEventCreate ? onScheduleJob : null,
  onPrintWorkOrder: hasCalendarEventUpdate ? onPrintWorkOrder : null,
  onSheeduleAppointment: hasCalendarEventCreate ? onSheeduleAppointment : null,
  updateSettings: updateSettings,
  onContextMenuClick: onContextMenuClick,
  onApptEditEventClick: onApptEditEventClick,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(EquipmentWeekView);
